import { call } from 'redux-saga/effects';
// import { showErrorMsg } from "../actions/snackbar";
import { logout } from './auth';
import { firebase } from '../context/firebase';

export function* validateSession(callback, ...args) {
	try {
		return yield call(callback, ...args);
	} catch (error) {
		const { response: { status } = {} } = error;
		if (status === 401) {
			firebase.analytics().logEvent('logout', { source: 'session_invalid' });
			yield call(logout);
			throw new Error('Session expired. Please login again');
		}
		throw error;
	}
}
